import React, { useEffect, useState } from 'react';
import axios from 'axios';
import FileViewer from './FileViewer';

const AuthenticatedDocumentViewer = ({
    document, src, requestConfig = {}, hasDocumentHeader, closeDialog
}) => {
    const [objectUrl, setObjectUrl] = useState(null);

    useEffect(() => {
        let currentObjectUrl = null;
        const requestSource = axios.CancelToken.source();

        axios.get(src, {
            ...requestConfig,
            responseType: 'blob',
            cancelToken: requestSource.token
        }).then(response => {
            currentObjectUrl = URL.createObjectURL(response.data);
            setObjectUrl(currentObjectUrl);
        }).catch(error => {
            if (!axios.isCancel(error)) {
                console.error('GET_DOCUMENT_CONTENT', error); // eslint-disable-line
            }
        });

        return () => {
            requestSource.cancel();
            if (currentObjectUrl) URL.revokeObjectURL(currentObjectUrl);
        };
    }, [src]);

    if (!objectUrl) return null;

    return (
        <FileViewer
            document={{ ...document, url: objectUrl }}
            hasDocumentHeader={hasDocumentHeader}
            closeDialog={closeDialog}
        />
    );
};

export default AuthenticatedDocumentViewer;
